import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const buttonVariants = cva(
  'inline-flex items-center border border-dark-100 justify-center whitespace-nowrap rounded-button text-questionName font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:bg-primary-blue-200 transition',
  {
    variants: {
      variant: {
        default:
          'bg-btn rounded-button hover:bg-btn/90 border- w-full text-questionName text-black font-medium',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        last: ' bg-primary-blue-400 w-full',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        // link: 'text-primary underline-offset-4 hover:underline',
        link: 'text-questionName underline-offset-4 hover:underline',
        multistep:
          'disabled:bg-[#34976014] disabled:text-buttonGradient w-full bg-buttonGradient border-none text-black !p-3',
        large: 'text-[20px] !p-4 font-bold border border-[#101A363D] text-[#101A36] rounded-full',
        largeFill:
          'text-[20px] !p-4 font-bold border border-[#101A363D] text-[white] rounded-full bg-[#101A36]',
      },
      size: {
        default: 'py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
    )
  },
)
Button.displayName = 'Button'

export { Button, buttonVariants }
